import React, { ReactElement } from "react";
import FaqItem from "./faq-item";
import { IAccordionItem } from "../../../genericTypes/sharedTypes";
import Head from "next/head";

export default function FaqList({
    items,
    className,
    faq,
}: {
    items: IAccordionItem[];
    className?: string;
    faq?: boolean;
}): ReactElement {
    return (
        <div>
            <Head>
                <script
                    type="application/ld+json"
                    id="faq-schema"
                    dangerouslySetInnerHTML={{
                        __html: `
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [
                            ${items
                                .map((item) => {
                                    return `{
                                        "@type": "Question",
                                        "name": "${item.question}",
                                        "acceptedAnswer": {
                                            "@type": "Answer",
                                            "text": "${item.answer
                                                ?.replace(/"/g, "'")
                                                ?.replace(
                                                    "<quillbot-extension-portal></quillbot-extension-portal>",
                                                    "",
                                                )
                                                ?.replace("\n", "")}"
                                        }
                                    }`;
                                })
                                .join(",")}
                            ]
                        }
                        `,
                    }}
                />
            </Head>
            {items?.map((item) => (
                <FaqItem
                    key={item.id}
                    item={item}
                    className={className}
                    faq={faq}
                />
            ))}
        </div>
    );
}
